import { render, staticRenderFns } from "./IngredientAdd.vue?vue&type=template&id=2e38534d&"
import script from "./IngredientAdd.vue?vue&type=script&lang=js&"
export * from "./IngredientAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IngredientAdd.vue"
export default component.exports